import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Stack } from '@mui/material';
import { t } from 'i18next';
import { ChangeEvent } from 'react';
import { Outlet } from 'react-router-dom';
import { BaseController, BaseState } from '../../../common/controllers/BaseController';
import { WithRouterProps, withRouter } from '../../../common/higher-order-components/with-router';
import { bind } from '../../../common/utils/decorators';
import { UrlHelper } from '../../../common/utils/UrlHelper';
import { PATHS } from '../../../routing/routes';
import { ReportOutletContextType } from '../../common/contexts/ReportOutletContext';
import { ReportDone } from '../../common/models/Report';

enum HandshakeType {
  TLS = 'tls',
  SSH = 'ssh',
}

type Props = WithRouterProps<ReportOutletContextType> & {};

type State = BaseState & {};

class Controller extends BaseController<Props, State> {
  private readonly reportId: number;

  constructor(props: Props, context: unknown) {
    super(props, context);

    ({ reportId: this.reportId } = this.parseNumericIds(['reportId']));
  }

  render() {
    const { report } = this.props.context;

    const enableToggle = report instanceof ReportDone;

    const isCurrentTls = UrlHelper.isCurrentPath(PATHS.REPORT_TLS_HANDSHAKES);
    const isCurrentSsh = UrlHelper.isCurrentPath(PATHS.REPORT_SSH_HANDSHAKES);

    return (
      <Stack gap={1}>
        <Stack direction="row" justifyContent="end" sx={{ mt: -1 }}>
          <FormControl component={Stack} sx={{ flexDirection: 'row', alignItems: 'center' }} gap={2} disabled={!enableToggle}>
            <FormLabel id="handshake-type-label">{t('handshakes.protocols.protocol')}</FormLabel>
            <RadioGroup row onChange={this.handleTypeChange} aria-labelledby="handshake-type-label" name="handshake-type-group">
              <FormControlLabel
                value={HandshakeType.TLS}
                control={<Radio checked={isCurrentTls} />}
                label={t('handshakes.protocols.tls')}
                aria-label={t('a11y.report.handshakes.viewTls')}
              />
              <FormControlLabel
                value={HandshakeType.SSH}
                control={<Radio checked={isCurrentSsh} />}
                label={t('handshakes.protocols.ssh')}
                aria-label={t('a11y.report.handshakes.viewTls')}
              />
            </RadioGroup>
          </FormControl>
        </Stack>
        {this.renderBase(<Outlet context={this.props.context} />)}
      </Stack>
    );
  }

  @bind
  private handleTypeChange(e: ChangeEvent<HTMLInputElement>) {
    const type = e.target.value as HandshakeType;
    if (type === HandshakeType.TLS) {
      this.navigate(UrlHelper.generatePath(PATHS.REPORT_TLS_HANDSHAKES, { reportId: this.reportId.toString() }));
    } else {
      this.navigate(UrlHelper.generatePath(PATHS.REPORT_SSH_HANDSHAKES, { reportId: this.reportId.toString() }));
    }
  }
}

export const ReportHandshakesController = withRouter(Controller);
